import { render, staticRenderFns } from "./AboutOurOrganisation.vue?vue&type=template&id=1e020758&"
import script from "./AboutOurOrganisation.vue?vue&type=script&lang=js&"
export * from "./AboutOurOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports